import { Link } from "react-router-dom";
import { Reveal, scrollToHash } from "@/lib/motion";
import { EVENT, BROCHURE, RATECARD } from "@/lib/site";

export default function Footer() {
  const go = (e, id) => {
    e.preventDefault();
    if (window.location.pathname !== "/") {
      window.location.href = `/#${id}`;
      return;
    }
    scrollToHash(id);
  };
  return (
    <footer data-testid="site-footer" className="bg-[#123d30] text-[#f3f3e9]">
      <div className="wrap border-b py-16 lg:py-20" style={{ borderColor: "rgba(243,243,233,.14)" }}>
        <Reveal className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
          <div>
            <span className="eyebrow text-[#d7ef8b]">Good food. Great connections.</span>
            <h2 className="mt-3 font-display text-3xl leading-tight sm:text-5xl">
              The future is organic.
              <br />
              <em className="italic text-[#d7ef8b]">Let's grow it together.</em>
            </h2>
          </div>
          <Link to="/register" data-testid="footer-cta" className="ofic-btn ofic-btn-lime">
            Join OFIC 2026 <span className="arrow">↗</span>
          </Link>
        </Reveal>
      </div>

      <div className="wrap grid gap-12 py-14 md:grid-cols-3">
        <div data-testid="footer-brand">
          <img src="/assets/ofic-mark.png" alt="OFIC 2026" className="h-12 w-auto" />
          <p className="mt-4 text-[12px] font-extrabold tracking-[0.18em] text-[#d7ef8b]">ORGANIC FOOD INDIA CONCLAVE 2026</p>
          <p className="mt-3 text-sm opacity-80">
            11 December, 2026
            <br />
            Ginger Hotel, Mumbai
          </p>
        </div>
        <div data-testid="footer-links">
          <span className="eyebrow text-[#d7ef8b]">Explore</span>
          <div className="mt-4 grid gap-2.5 text-sm">
            {[["about", "The conclave"], ["why-attend", "Reasons to attend"], ["expo", "OFIC Expo 2026"], ["exhibitors", "Exhibitor profile"], ["participants", "Participants & presenters"], ["gallery", "OFIC 2019 gallery"]].map(([id, label]) => (
              <a key={id} href={`#${id}`} onClick={(e) => go(e, id)} className="no-underline opacity-80 transition-opacity hover:opacity-100">
                {label}
              </a>
            ))}
            <a href={BROCHURE} target="_blank" rel="noreferrer" className="no-underline opacity-80 hover:opacity-100">Event brochure ↗</a>
            <a href={RATECARD} target="_blank" rel="noreferrer" className="no-underline opacity-80 hover:opacity-100">Participation rates ↗</a>
            <a href="/assets/layout.pdf" target="_blank" rel="noreferrer" className="no-underline opacity-80 hover:opacity-100">Expo floor plan ↗</a>
          </div>
        </div>
        <div data-testid="footer-contact">
          <span className="eyebrow text-[#d7ef8b]">Let's connect</span>
          <div className="mt-4 grid gap-2.5 text-sm">
            <a href={`mailto:${EVENT.email}`} className="no-underline opacity-80 hover:opacity-100">{EVENT.email} ↗</a>
            {EVENT.phones.map((p) => (
              <a key={p} href={`tel:${p.replace(/\s/g, "")}`} className="no-underline opacity-80 hover:opacity-100">{p}</a>
            ))}
          </div>
          <a href={EVENT.organiserUrl} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-3 no-underline">
            <span className="eyebrow text-[10px] opacity-70">Organised by</span>
            <img src="/assets/teflas-mark.png" alt="Tefla's" className="h-7 w-auto" />
          </a>
        </div>
      </div>

      <div className="wrap flex items-center justify-between border-t py-6 text-xs opacity-75" style={{ borderColor: "rgba(243,243,233,.14)" }}>
        <span data-testid="footer-copyright">© 2026 Tefla's. All rights reserved.</span>
        <button onClick={() => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))} data-testid="footer-back-to-top" className="bg-transparent font-bold no-underline">
          Back to top ↑
        </button>
      </div>

      <div className="overflow-hidden pb-6" aria-hidden="true">
        <p className="whitespace-nowrap text-center font-display text-[18vw] leading-none opacity-[0.07]">
          OFIC 2026 <span className="text-[#d7ef8b]">✳</span>
        </p>
      </div>
    </footer>
  );
}
